import { FC, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ValidIcon } from '../assets/ValidIcon';
import { Link } from 'react-router-dom'
import { AppContext } from '../App';

export const UploadComplete: FC = () => {
    const { accountNumberReq, setAccountNumberReq } = useContext(AppContext);
    const navigate = useNavigate();

    useEffect(() => {
        !accountNumberReq.uuid && navigate('/');
    });
    return (
        <div className="page">

            <div className="container">

                <div className="u-m__b--l">
                    <ValidIcon />
                </div>

                <h1 className="page__title u-m__b--l">Your files have been successfully uploaded</h1>

                <div className="u-m__b--l">
                    <p className="u-m__b">Thank you.</p>
                    <p>The files have been sent to Financial Wellness Group. We will review these and get back to you.</p>
                </div>

                <Link to="/file-type"><button className="btn--ghost">Back</button></Link>
            </div>
        </div>
    )
};
